var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4445 13.3449C13.9603 12.8292 14.25 12.1297 14.25 11.4004C14.25 10.671 13.9603 9.97157 13.4445 9.45585C12.9288 8.94012 12.2293 8.65039 11.5 8.65039C10.7707 8.65039 10.0712 8.94012 9.55546 9.45585C9.03973 9.97157 8.75 10.671 8.75 11.4004C8.75 12.1297 9.03973 12.8292 9.55546 13.3449C10.0712 13.8607 10.7707 14.1504 11.5 14.1504C12.2293 14.1504 12.9288 13.8607 13.4445 13.3449Z",
    stroke: "#4A9DE6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75293 11.401C3.92076 7.68212 7.39585 4.98438 11.4998 4.98438C15.6046 4.98438 19.0788 7.68212 20.2466 11.401C19.0788 15.12 15.6046 17.8177 11.4998 17.8177C7.39585 17.8177 3.92076 15.12 2.75293 11.401Z",
    stroke: "#4A9DE6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEye);
export default __webpack_public_path__ + "static/media/ic_eye.60af6aab06afcffa8572103c48e62a8a.svg";
export { ForwardRef as ReactComponent };